// extracted by mini-css-extract-plugin
module.exports = {"header":"StaticWidgetsForBusinessUser_header__1Dw5U","count":"StaticWidgetsForBusinessUser_count__zicwW","value":"StaticWidgetsForBusinessUser_value__1tTi2"};